module.exports = flarum.core.compat['tags/common/utils/sortTags'];